import React from "react"
import { Box, Typography } from "@mui/material"

export default function ViolationPieChart({ data, size = 312, radius = 96 }) {
    // ⬆️  size: 260 → 312 (20% larger)
    // ⬆️  radius: 80 → 96 (20% larger)

    const total = data.reduce((a, b) => a + b.value, 0)
    const cx = size / 2
    const cy = size / 2
    const baseLabelRadius = radius + 40 // slightly increased to match new chart size
    const strokeW = 4

    const polar = (angleDeg, r) => {
        const rad = (Math.PI / 180) * (angleDeg - 90)
        return [r * Math.cos(rad), r * Math.sin(rad)]
    }

    const arcPath = (startAngle, endAngle) => {
        const [x1, y1] = polar(startAngle, radius)
        const [x2, y2] = polar(endAngle, radius)
        const largeArc = endAngle - startAngle > 180 ? 1 : 0
        return `M 0 0 L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2} Z`
    }

    let current = 0
    const slices = data.map((d) => {
        const sweep = (d.value / total) * 360
        const start = current
        const end = current + sweep
        const mid = start + sweep / 2
        current = end

        const rad = (Math.PI / 180) * (mid - 90)
        const cos = Math.cos(rad)
        const sin = Math.sin(rad)

        // quadrant-based label offset
        let offset = 0
        if (sin > 0 && cos < 0) offset = 20
        else if (sin < 0 && cos < 0) offset = 30
        else if (sin < 0 && cos > 0) offset = 20
        else offset = 10

        const [lx, ly] = polar(mid, baseLabelRadius + offset)
        const isRight = cos >= 0

        return { ...d, start, end, mid, lx, ly, isRight }
    })

    return (
        <Box
            sx={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: size + 70, // adjust to match new scale
            }}
        >
            <svg
                width={size}
                height={size}
                viewBox={`${-cx} ${-cy} ${size} ${size}`}
                style={{ display: "block" }}
            >
                {slices.map((s, i) => (
                    <path
                        key={i}
                        d={arcPath(s.start, s.end)}
                        fill={s.color}
                        stroke="#fff"
                        strokeWidth={strokeW}
                    />
                ))}
            </svg>

            {/* Labels */}
            {slices.map((s, i) => (
                <Typography
                    key={`lbl-${i}`}
                    sx={{
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: `translate(calc(${s.lx}px - 50%), calc(${s.ly}px - 50%))`,
                        textAlign: s.isRight ? "left" : "right",
                        whiteSpace: "nowrap",
                        fontSize: "14px",
                        fontWeight: 600,
                        color: s.color,
                        pointerEvents: "none",
                    }}
                >
                    {s.name}: {s.value}
                </Typography>
            ))}
        </Box>
    )
}
